import React from "react";
import "./MenuItems.css";

function MenuItems({ items }) {
  return (
    <div className="menu-items">
      {items.map(item => (
        <div className="menu-card" key={item.id}>
          <img src={item.img} alt={item.name} className="menu-img" />
          <div className="menu-info">
            <div className="menu-row">
              <h3>{item.name}</h3>
              <p className="price">{item.price},00 DZD</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MenuItems;